/**
 * Espelho do permission.registry.ts da API.
 * Sincronize esta lista ao adicionar/remover permissões no backend.
 */
export const PERMISSIONS = {
  // Role management
  ROLE_CREATE: 'role:create',
  ROLE_READ: 'role:read',
  ROLE_UPDATE: 'role:update',
  ROLE_DELETE: 'role:delete',

  // User management
  USER_CREATE: 'user:create',
  USER_LIST: 'user:list',
  USER_READ: 'user:read',
  USER_UPDATE: 'user:update',
  USER_ACTIVATE: 'user:activate',
  USER_DEACTIVATE: 'user:deactivate',
  USER_RESET_PASSWORD: 'user:reset-password',
  USER_IMPORT: 'user:import',

  // MFA
  MFA_RESET: 'mfa:reset',

  // Visit reports
  VISIT_REPORT_CREATE: 'visit-report:create',
  VISIT_REPORT_READ: 'visit-report:read',

  // Agenda
  AGENDA_READ: 'agenda:read',
  AGENDA_ANALYSIS_FEEDBACK_READ: 'agenda-analysis:feedback:read',

  // Audit
  AUDIT_READ: 'audit:read',

  // Feature flags (navega_staff)
  FEATURE_FLAGS_READ: 'feature-flags:read',
  FEATURE_FLAGS_MANAGE: 'feature-flags:manage',

  // Parameters (navega_staff)
  PARAMETERS_READ: 'parameters:read',
  PARAMETERS_MANAGE: 'parameters:manage',

  // Management (navega_staff)
  MANAGEMENT_READ: 'management:read',
  MANAGEMENT_WRITE: 'management:write',

  // Logs (navega_staff)
  LOGS_READ: 'logs:read',
} as const

export type Permission = (typeof PERMISSIONS)[keyof typeof PERMISSIONS]
